import { render, staticRenderFns } from "./BusinessProgressPlan.vue?vue&type=template&id=63ad7afd&"
import script from "./BusinessProgressPlan.vue?vue&type=script&lang=js&"
export * from "./BusinessProgressPlan.vue?vue&type=script&lang=js&"
import style0 from "./BusinessProgressPlan.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports